import { render, staticRenderFns } from "./GatewayAsset.vue?vue&type=template&id=64ed3eae"
import script from "./GatewayAsset.vue?vue&type=script&lang=js"
export * from "./GatewayAsset.vue?vue&type=script&lang=js"
import style0 from "./GatewayAsset.vue?vue&type=style&index=0&id=64ed3eae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports